import React from "react"
import { ShelfItemBookEntity } from "@/app/entities/ShelfEntity"
import { useBookshelfExtractStore } from "../_store/useBookshelfExtractStore"
import BookItem from "./BookItem"

interface BookListProps {
  books: ShelfItemBookEntity[]
}

/**
 * 도서 목록 컴포넌트
 * 개별 BookItem들을 렌더링하고 선택 상태를 관리
 */
const BookList = React.memo<BookListProps>(({ books }) => {
  const { selectedBooks, toggleBookSelection } = useBookshelfExtractStore()

  return (
    <div className="flex flex-1 flex-col gap-[10px] px-5 pb-6 sm:px-8">
      {books.map((book) => (
        <BookItem
          key={book.id}
          book={book}
          isSelected={book.isbn ? selectedBooks.has(book.isbn) : false}
          onToggle={toggleBookSelection}
        />
      ))}
    </div>
  )
})

BookList.displayName = "BookList"

export default BookList
